<template>
  <div>
    <Modal :title="editAggregateName ? `编辑主机聚合「${editAggregateName}」` : `添加主机聚合`" v-model="editAggregateModal" width="800">
      <Alert show-icon type="error" v-if="editAggregateError">{{ editAggregateErrorMsg }}</Alert>
      <Alert show-icon>主机聚合通过将主机组合到一起来把可用区域划分成逻辑单元。</Alert>
      <Form ref="editAggregateForm" :model="editAggregateForm" :rules="editAggregateRules">
        <FormItem label="聚合名称" style="width: 100%" prop="name">
          <Input v-model="editAggregateForm.name" />
        </FormItem>
        <FormItem label="区域" style="width: 100%" prop="availability_zone">
          <Input v-model="editAggregateForm.availability_zone" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="editAggregateSubmit" :loading="editAggregateSubmitting">提交</Button>
        <Button @click="editAggregateModal = false">取消</Button>
      </div>
    </Modal>
    <Modal title="管理主机" v-model="mangeHostModal" width="700">
      <transfer
        :data="hosts"
        :target-keys="mangeHostForm.hosts"
        @on-change="mangeHostChange"
        :list-style="{
          width: '300px',
          height: '400px'
        }"
        :titles="['所有可用主机', '选中的主机']"
        not-found-text="无可用主机"
        filterable></transfer>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="mangeHostSubmit" :loading="mangeHostSubmitting">提交</Button>
        <Button @click="mangeHostModal = false">取消</Button>
      </div>
    </Modal>
    <Card shadow class="content">
      <div class="main">
        <Alert v-if="error" show-icon type="error">
          获取数据失败
          <a style="float: right" v-on:click="getAggregates"><Icon type="md-refresh" size="18" /></a>
        </Alert>
        <div v-else>
          <Row>
            <h4 style="float: left">主机聚合列表</h4>
            <div style="float: right;" class="align-right">
              <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getAggregates">刷新</Button>
              <Button
                @click="openEditModal"
                :style="{marginBottom: '10px'}"
                icon="md-add">添加主机聚合</Button>
            </div>
          </Row>
          <Alert v-if="operateErrorMsg" show-icon type="error">{{ operateErrorMsg }}</Alert>
          <Table
            :loading="tableLoading"
            ref="table"
            :data="aggregates"
            :columns="columns">
          </Table>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudAggregate, editPrivateCloudAggregate, updatePrivateCloudAggregateHosts,
  deletePrivateCloudAggregate } from '@/api/private-cloud/aggregate'
import { getPrivateCloudComputeServices } from '@/api/private-cloud/compute-services'

export default {
  name: 'aggregate',
  data () {
    return {
      error: false,
      operateErrorMsg: null,
      aggregates: [],
      columns: [
        {
          title: '名称',
          key: 'name',
          align: 'center',
          minWidth: 150
        },
        {
          title: '区域',
          key: 'availability_zone',
          align: 'center',
          minWidth: 200
        },
        {
          title: '主机',
          key: 'hosts',
          align: 'center',
          minWidth: 200,
          render: (h, params) => {
            let hosts = params.row.hosts.map(item => h('Tag', item))
            return h('div', hosts)
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 190,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.openEditModal(params.row)
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.mangeHostForm.id = params.row.id
                    this.mangeHostForm.hosts = params.row.hosts
                    this.mangeHostModal = true
                  }
                }
              }, '管理主机'),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  transfer: true,
                  title: '你确定要删除该主机聚合吗？'
                },
                on: {
                  'on-ok': () => {
                    this.deleteRole(params.row.id)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '删除')
              ])
            ])
          }
        }
      ],
      tableLoading: false,
      // 编辑主机聚合
      editAggregateModal: false,
      editAggregateSubmitting: false,
      editAggregateError: false,
      editAggregateErrorMsg: null,
      editAggregateName: null,
      editAggregateForm: {
        id: '',
        name: '',
        availability_zone: ''
      },
      editAggregateRules: {
        name: { required: true, message: '名称是必填的', trigger: 'blur' }
      },
      // 管理主机
      hosts: [],
      mangeHostModal: false,
      mangeHostSubmitting: false,
      mangeHostForm: {
        id: '',
        hosts: []
      }
    }
  },
  created: function () {
    this.getAggregates()
    this.getComputeServices()
  },
  methods: {
    getAggregates () {
      this.tableLoading = true
      getPrivateCloudAggregate().then(res => {
        this.aggregates = res.data
        this.error = false
        this.tableLoading = false
      }).catch(res => {
        this.error = true
        this.tableLoading = false
        console.error(res.response)
      })
    },
    getComputeServices () {
      const reqData = {
        binary: 'nova-compute'
      }
      getPrivateCloudComputeServices(reqData).then(res => {
        this.hosts = res.data.services.map(item => {
          return {
            key: item.host,
            value: item.host
          }
        })
      })
    },
    openEditModal (row) {
      if (row) {
        this.editAggregateForm = {
          id: row.id,
          name: row.name,
          availability_zone: row.availability_zone
        }
        this.editAggregateName = row.name
      } else {
        this.editAggregateForm.id = ''
        this.editAggregateName = null
      }
      this.editAggregateModal = true
    },
    editAggregateSubmit () {
      this.$refs.editAggregateForm.validate((valid) => {
        if (valid) {
          this.editAggregateSubmitting = true
          editPrivateCloudAggregate(this.editAggregateForm, this.editAggregateForm.id).then(res => {
            this.editAggregateSubmitting = false
            this.editAggregateError = false
            this.editAggregateErrorMsg = null
            this.editAggregateModal = false
            this.getAggregates()
            this.$Notice.success({title: '操作成功'})
          }).catch(res => {
            this.editAggregateSubmitting = false
            console.error(res.response)
            this.$Notice.error({title: '操作失败'})
            this.editAggregateErrorMsg = res.response.data
            this.editAggregateError = true
          })
        }
      })
    },
    deleteRole (id) {
      deletePrivateCloudAggregate(id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getAggregates()
        this.operateErrorMsg = null
      }).catch(res => {
        if (res.response) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.response.data
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
        this.operateErrorMsg = res.response.data
      })
    },
    mangeHostChange (targetData) {
      this.mangeHostForm.hosts = targetData
    },
    mangeHostSubmit () {
      const reqData = {
        hosts: this.mangeHostForm.hosts
      }
      this.mangeHostSubmitting = true
      updatePrivateCloudAggregateHosts(reqData, this.mangeHostForm.id).then(res => {
        this.mangeHostSubmitting = false
        this.getAggregates()
        this.mangeHostModal = false
        if (res.data.have_error) {
          let errorHosts = []
          for (let i in res.data.have_error) {
            errorHosts.push(`「${i}: ${JSON.stringify(res.data.have_error[i])}」`)
          }
          this.operateErrorMsg = `部分主机修改异常, 请检查: ${errorHosts.join('; ')}`
          this.$Notice.warning({title: '部分主机修改异常, 请检查'})
        } else {
          this.operateErrorMsg = null
          this.$Notice.success({title: '操作成功'})
        }
      }).catch(res => {
        this.mangeHostSubmitting = false
        console.log(res.response)
        this.$Notice.error({title: '操作失败'})
      })
    }
  }
}
</script>

<style scoped>

</style>
